module.exports = __webpack_public_path__ + "img/nose.68a2e9ca.svg";